var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Upload',{ref:"upload",staticStyle:{"display":"inline-block"},attrs:{"action":_vm.attrs.api,"headers":_vm.headers,"on-success":_vm.handleSuccess,"data":_vm.fromdata}},[_c('Button',{attrs:{"icon":"ios-cloud-upload-outline"}},[_vm._v(_vm._s(_vm.attrs.title))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a7156c6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../projectCore/src/components/file-upload/src/index.vue
// module id = null
// module chunks = 